
const digest = 'b7868d9b5cea47f4a91aa6159b757ed1246e41fd8d214a6efe19c47eae2c36cd';
const classes = {"errorMessage":"_errorMessage_v5of3_1","invalid":"_invalid_v5of3_7"};
const css = `._errorMessage_v5of3_1 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  color: red;
}

._invalid_v5of3_7 {
  border-color: red !important;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  